import { Box } from "@mui/material";
import React, { useEffect } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { getNewsFeed, hideError } from "../redux/action";

import {
  BottomNav,
  DefaultLoader,
  NewsCard,
  StepLabel
} from "../../components";

const NewsList = props => {
  const {
    loading,
    history,
    newsFeed,
    getNewsFeed,
  } = props;

  /**
   * @function Navigate back to previous screen
   *    if New User go back to get started screen
   *    else redirect to dashboard screen
   */
  const handleBack = () => {
    history.back();
  };

  useEffect(() => {
    getNewsFeed();
  }, []);

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: "#f6f6f8",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {loading && <DefaultLoader />}

      <StepLabel
        title="What's New"
        containerStyles={{ margin: "16px 16px 22px" }}
        onClick={handleBack}
      />

      {newsFeed && newsFeed.length > 0 ? (
        <>
          {newsFeed
            .sort((a, b) => a.dataIndex - b.dataIndex)
            .map((item, index) => {
              return (
                <div
                  key={index}
                  style={{ margin: "0 16px", paddingTop: "8px" }}
                >
                  <NewsCard
                    key={index}
                    image={item.imageUrl}
                    title={item.name}
                    url={item.articleUrlEn}
                    date={item.lastUpdated}
                  />
                </div>
              );
            })}
        </>
      ) : null}

      {/* Bottom Navigation */}
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          width: "100%",
          display: "inline-block",
          marginTop: "auto",
        }}
      >
        <BottomNav />
      </Box>
    </Box>
  );
};

const withConnect = connect(
  state => ({
    isModalOpen: state.goal.isModalOpen,
    newsFeed: state.goal.newsFeed,
  }),
  { getNewsFeed, hideError }
);

export default compose(
  withRouter,
  withConnect
)(NewsList);
